module.exports = __webpack_public_path__ + "static/media/keyboard-icon.61681d7f.svg";